import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';
import { getNavigationToken } from './themeTokens';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  // 静态兜底值；真正生效的 navTheme 由 getSettingsWithSiderWidth() 从存储读取，
  // 这里不能写死 realDark，否则会与用户选择的浅色主题冲突。
  navTheme: 'light',
  colorPrimary: '#18181B',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  siderWidth: 208,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: getNavigationToken('light'),
  splitMenus: true,
  menu: { defaultOpenAll: true, ignoreFlatMenu: true, autoClose: false },
};
export default Settings;
